<template>
  <section class="webninars">
    <div class="webninars__banner">
      <TopBanner :item="banner" class="_mb-16" />
    </div>
    <div class="container _py-16 _py-md-12" v-if="getWebinarsList !== null">
      <div
        class="sections__list d-grid row-1-1 gap-32"
        :key="paginationList.length"
      >
        <VideoCard
          @like="likeWebinar"
          @favorite="favoriteWebinar"
          @downloadFile="downloadFile"
          @viewItem="viewItem"
          @setVideoProgress="setVideoProgress"
          v-for="(block, ind) in paginationList"
          :key="paginationList.length + ind"
          :item="getTranslate(block)"
          :analyticEventPrefix="'webinars_material'"
        >
          <template v-slot:image>
            <img :src="block.image" alt="" />
          </template>
          <template v-slot:button="props">
            <div class="_px-md-4 _px-0">
              <AppBtn
                v-if="props.item.links.length || props.item.materials.length"
                class="_py-3 _px-4 _mb-4 _mt-4"
                :btnClass="'btn_secondary'"
                @click.native="openMaterials(props.item)"
              >
                <span class="d-flex">
                  <svg
                    class="_mr-2"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 7C12 5.93913 11.5786 4.92172 10.8284 4.17157C10.0783 3.42143 9.06087 3 8 3H2V18H9C9.79565 18 10.5587 18.3161 11.1213 18.8787C11.6839 19.4413 12 20.2044 12 21M12 7V21M12 7C12 5.93913 12.4214 4.92172 13.1716 4.17157C13.9217 3.42143 14.9391 3 16 3H22V18H15C14.2044 18 13.4413 18.3161 12.8787 18.8787C12.3161 19.4413 12 20.2044 12 21"
                      stroke="#629727"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>

                  <span class="_fs-16 _lh-24">{{
                    $t("interface.video.materials")
                  }}</span>
                </span>
              </AppBtn>
            </div>
          </template>
        </VideoCard>
      </div>
      <Pagination
        :itemsCount="filteredWebinarsList.length"
        @rangeChange="rangeChange"
      />
    </div>
    <div class="d-flex justify-center _my-6" v-else>
      <Preloader />
    </div>
    <div class="_bg-light">
      <div class="container">
        <OtherMain :items="sectionsList" :analyticEventPrefix="'webinars_'">
          <template v-slot:title>
            <div
              class="section-detail__title _fs-32 _lh-38 _fs-sm-24 _lh-sm-32 _fw-600"
            >
              {{ $t("another_sections_title") }}
            </div>
          </template>
        </OtherMain>
      </div>
    </div>
    <Modal
      class="webinars__modal"
      v-if="stateMaterials"
      @close="modalToggle('stateMaterials', false)"
    >
      <template v-slot:modalBody>
        <div class="modal__body">
          <div
            class="modal__title _fs-sm-24 _lh-sm-32 _fs-32 _lh-38 _fw-700 _tc-dark _mb-6"
          >
            {{ $t("modals.additional_materials.materials") }}
          </div>
          <div class="materials__list" v-if="currentMaterials || currentLinks">
            <AdditionalMaterialCard
              @like="likeMaterial"
              @favorite="favoriteMaterial"
              v-for="material in currentMaterials"
              :key="material.id"
              :material="material"
              :analyticEventPrefix="'webinars_additional_docs_'"
            />
            <div class="_fs-24 _lh-32 _tc-dark _mt-6 _mb-4 _fw-700">
              {{ $t("modals.additional_materials.links") }}
            </div>
            <div class="materials__list" v-if="currentLinks">
              <AdditionalMaterialCard
                @like="likeLink"
                @favorite="favoriteLink"
                :type="'links'"
                v-for="(material, i) in currentLinks"
                :key="i"
                :material="material"
                :analyticEventPrefix="'webinars_additional_docs_'"
              />
            </div>
          </div>
        </div>
      </template>
    </Modal>
  </section>
</template>

<script>
import { bus } from "@/main";
import TopBanner from "@/components/UI/banners/TopBanner";
import VideoCard from "@/components/UI/cards/VideoCard";
import AdditionalMaterialCard from "@/components/UI/cards/AdditionalMaterialCard";
import Pagination from "../../components/UI/pagination/Pagination.vue";
import OtherMain from "@/components/UI/OtherMain";
import Modal from "@/components/UI/Modal";
import Preloader from "@/components/UI/Preloader";
import download from "@/mixins/download";

import { mapActions, mapGetters, mapMutations } from "vuex";
import AppBtn from "../../components/UI/buttons/AppBtn.vue";

export default {
  metaInfo() {
    return { title: this.$t("interface.menu.webinars") };
  },
  name: "WebinarsMain",
  components: {
    TopBanner,
    VideoCard,
    Pagination,
    OtherMain,
    AppBtn,
    Modal,
    AdditionalMaterialCard,
    Preloader,
  },
  mixins: [download],
  data: () => ({
    startRange: 0,
    endRange: 3,
    stateMaterials: false,
    currentMaterials: null,
    materialsWebinarId: null,
    currentLinks: null,
  }),
  computed: {
    ...mapGetters(["Sections", "getWebinarsList"]),
    sectionsList() {
      const vm = this;
      return this.$t("another_sections") &&
        Array.isArray(this.$t("another_sections"))
        ? this.$t("another_sections")
            .filter((el) => !el.hide)
            .map(function (el) {
              return {
                ...el,
                image: require(`@/assets/img/sections/${el.image}`),
                route: vm.helpers.buildRoute(el.route),
              };
            })
        : null;
    },
    currentLocale() {
      return this.Trans.currentLocale;
    },
    paginationList() {
      return this.filteredWebinarsList.slice(this.startRange, this.endRange);
    },
    filteredWebinarsList() {
      if (this.$route.params.filtered) {
        return this.getWebinarsList.filter((el) => !el.view).length
          ? this.getWebinarsList.filter((el) => !el.view)
          : this.getWebinarsList;
      } else {
        return this.getWebinarsList;
      }
    },
    banner() {
      return {
        title: this.$t("pages.webinars.title"),
        descr: this.$t('pages.webinars.description'),
        theme: "dark",
        images: [
          {
            src: require("@/assets/img/banners/webinars/MW-mob.jpg"),
            media: "(max-width: 743px)",
          },
          {
            src: require("@/assets/img/banners/webinars/MW-tab.jpg"),
            media: "(max-width: 1220px)",
          },
          {
            src: require("@/assets/img/banners/webinars/MW-1440.jpg"),
            media: "(max-width: 1919px)",
          },
          {
            src: require("@/assets/img/banners/webinars/MW-1920.jpg"),
            media: "(min-width: 1920px)",
          },
        ],
      };
    },
  },
  methods: {
    ...mapActions([
      "fetchWebinarsList",
      "WebinarsSetLike",
      "WebinarsSetFavorite",
      "WebinarsSetVideoProgress",
      "WebinarsMaterialSetLike",
      "WebinarsMaterialSetFavorite",
      "WebinarsLinkSetLike",
      "WebinarsLinkSetFavorite",
      "WebinarsSetView",
    ]),
    ...mapMutations(["setWebinarsList"]),
    rangeChange(start, end) {
      this.startRange = start;
      this.endRange = end;
    },
    openMaterials(item) {
      this.stateMaterials = true;
      this.currentMaterials = item.materials;
      this.currentLinks = item.links;
      this.materialsWebinarId = item.id;
      bus.$emit("scrollLock", true);
      if (this.$gtm) {
        this.$gtm.push({
          event: "webinars_additional_docs",
          param_value: this.helpers.stripHtml(this.getTranslate(item).title),
        });
      }
    },
    modalToggle(model, state) {
      this[model] = state;
      this.currentMaterials = null;
      this.currentLinks = null;
      this.materialsWebinarId = null;
      bus.$emit("scrollLock", state);
    },
    getTranslate(item) {
      return {
        ...item,
        title: item.translates[0].title,
        description: item.translates[0].description,
        preview: item.translates[0].preview,
        file: item.translates[0].file || item.translates[0].file_link,
        file_size: item.translates[0].file_size,
        speakers: item.translates[0].speakers,
        materials: item.translates[0].materials,
        links: item.translates[0].links,
        extras: item.translates[0].extras,
      };
    },
    async updateList() {
      await this.fetchWebinarsList({
        lang: this.currentLocale,
        type: "new_webinars",
      });
    },
    async likeWebinar(id) {
      await this.WebinarsSetLike(id);
      await this.updateList();
    },
    async favoriteWebinar(id) {
      await this.WebinarsSetFavorite(id);
      await this.updateList();
    },
    async likeMaterial(id) {
      await this.WebinarsMaterialSetLike(id);
      await this.updateList();
      this.currentMaterials = this.getTranslate(
        this.filteredWebinarsList.find(
          (el) => el.id === this.materialsWebinarId
        )
      ).materials;
    },
    async favoriteMaterial(id) {
      await this.WebinarsMaterialSetFavorite(id);
      await this.updateList();
      this.currentMaterials = this.getTranslate(
        this.filteredWebinarsList.find(
          (el) => el.id === this.materialsWebinarId
        )
      ).materials;
    },
    async likeLink(id) {
      await this.WebinarsLinkSetLike(id);
      await this.updateList();
      this.currentLinks = this.getTranslate(
        this.filteredWebinarsList.find(
          (el) => el.id === this.materialsWebinarId
        )
      ).links;
    },
    async favoriteLink(id) {
      await this.WebinarsLinkSetFavorite(id);
      await this.updateList();
      this.currentLinks = this.getTranslate(
        this.filteredWebinarsList.find(
          (el) => el.id === this.materialsWebinarId
        )
      ).links;
    },
    async setVideoProgress(id, time) {
      await this.WebinarsSetVideoProgress({
        id: id,
        progress: Math.round(time),
      });
      await this.updateList();
    },
    async viewItem(id) {
      await this.WebinarsSetView(id);
      await this.updateList();
    },
  },
  async mounted() {
    await this.fetchWebinarsList({
      lang: this.currentLocale,
      type: "new_webinars",
    });
  },
  destroyed() {
    this.setWebinarsList(null);
  },
};
</script>

<style lang="scss">
.webninars {
  &__banner {
    background-color: #CEE9F1;
  }

  .top-banner {
    max-width: 1920px;
    margin: 0 auto;
  }
}
.row-1-1 {
  grid-template-columns: 1fr 1fr;

  @media screen and (max-width: 1220px) {
    grid-template-columns: 1fr;
  }
}

.gap-32 {
  grid-gap: 32px;
}

.webinars__modal {
  & .modal {
    max-width: 900px;
  }
}
</style>
